import { MODULE_NAME } from '../constants';

export const PREFETCH_SEARCH_LISTING_DATA = `${MODULE_NAME}/PREFETCH_SEARCH_LISTING_DATA`;
export const PREFETCH_SEARCH_LISTING_DATA_SUCCESS = `${MODULE_NAME}/PREFETCH_SEARCH_LISTING_DATA_SUCCESS`;
export const PREFETCH_SEARCH_LISTING_DATA_ERROR = `${MODULE_NAME}/PREFETCH_SEARCH_LISTING_DATA_ERROR`;
export const FETCH_SEARCH_LISTING_DATA = `${MODULE_NAME}/FETCH_SEARCH_LISTING_DATA`;
export const FETCH_SEARCH_LISTING_DATA_SUCCESS = `${MODULE_NAME}/FETCH_SEARCH_LISTING_DATA_SUCCESS`;
export const FETCH_SEARCH_LISTING_DATA_ERROR = `${MODULE_NAME}/FETCH_SEARCH_LISTING_DATA_ERROR`;
